var React = require('react');

function ErrorX (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1 {\n        fill: #762a82;\n      }\n    ")),React.createElement("path",{"className":"cls-1","d":"M2372.89,2325.12l-182.67,182.67c-48.18,48.18-158.55,50.21-208.69.07l-521.44-521.44-521.9,521.9c-48.18,48.18-158.59,50.25-208.73.11l-182.49-182.49c-50.14-50.14-48.07-160.54.11-208.73l519.91-519.91-521.44-521.44c-50.14-50.14-48.11-160.5.07-208.69l184.67-184.67c48.18-48.18,158.55-50.22,208.69-.07l521.44,521.44,521.91-521.91c48.18-48.18,158.55-50.22,208.69-.08l182.49,182.49c50.14,50.14,48.1,160.52-.07,208.7l-521.91,521.91,521.44,521.44c50.14,50.14,48.11,160.51-.07,208.7Z","key":1})]);
}

ErrorX.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 3095.59 3095.59"};

module.exports = ErrorX;

ErrorX.default = ErrorX;
